export class TypedObject {
    static keys(obj) {
        return Object.keys(obj);
    }
    static values(obj) {
        return Object.values(obj);
    }
}
